module.exports = __webpack_public_path__ + "media/images/loading-wheel-gif-62ce6005e4ad1473bf3ba64e8175c175.gif";